import arrietty from "./arrietty.jpg";
import castle from "./castle.png";
import cat from "./cat.jpg";
import earthsea from "./earthsea.jpg";
import grave from "./grave.jpg";
import howl from "./howl.jpg";
import kaguya from "./kaguya.jpg";
import kiki from "./kiki.jpg";
import marnie from "./marnie.jpg";
import mononoke from "./mononoke.jpg";
import poko from "./poko.jpg";
import ponyo from "./ponyo.jpg";
import poppy from "./poppy.jpg";
import porco from "./porco.jpg";
import spirited from "./spirited.jpg";
import totoro from "./totoro.jpg";
import whisper from "./whisper.jpg";
import wind from "./wind.jpg";
import yamada from "./yamada.jpg";
import yesterday from "./yesterday.jpg";

export const images = [{
    id: "2de9426b-914a-4a06-a3a0-5e6d9d3886f6",
    url: arrietty
}, {
    id: "2baf70d1-42bb-4437-b551-e5fed5a87abe",
    url: castle
}, {
    id: "90b72513-afd4-4570-84de-a56c312fdf81",
    url: cat
}, {
    id: "112c1e67-726f-40b1-ac17-6974127bb9b9",
    url: earthsea
}, {
    id: "12cfb892-aac0-4c5b-94af-521852e46d6a",
    url: grave
}, {
    id: "cd3d059c-09f4-4ff3-8d63-bc765a5184fa",
    url: howl
}, {
    id: "578ae244-7750-4d9f-867b-f3cd3d6fecf4",
    url: kaguya
}, {
    id: "ea660b10-85c4-4ae3-8a5f-41cea3648e3e",
    url: kiki
}, {
    id: "5fdfb320-2a02-49a7-94ff-5ca418cae602",
    url: marnie
}, {
    id: "0440483e-ca0e-4120-8c50-4c8cd9b965d6",
    url: mononoke
}, {
    id: "1b67aa9a-2e4a-45af-ac98-64d6ad15b16c",
    url: poko
}, {
    id: "758bf02e-3122-46e0-884e-67cf83df1786",
    url: ponyo
}, {
    id: "45db04e4-304a-4933-9823-33f389e8d74d",
    url: poppy
}, {
    id: "ebbb6b7c-945c-41ee-a792-de0e43191bd8",
    url: porco
}, {
    id: "dc2e6bd1-8156-4886-adff-b39e6043af0c",
    url: spirited
}, {
    id: "58611129-2dbc-4a81-a72f-77ddfc1b1b49",
    url: totoro
}, {
    id: "ff24da26-a969-4f0e-ba1e-a122ead6c6e3",
    url: whisper
}, {
    id: "67405111-37a5-438f-81cc-4666af60c800",
    url: wind
}, {
    id: "45204234-adfd-45cb-a505-a8e7a676b114",
    url: yamada
}, {
    id: "4e236f34-b981-41c3-8c65-f8c9000b94e7",
    url: yesterday
},
];